import React, { Fragment, ReactNode } from 'react';
import { TextField, Typography, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
    title: string;
    text: string | ReactNode;
    confirmationIsValid?: boolean;
    setConfirmationIsValid?: DispatchState<boolean>;
};

export default function ConfirmationStep({
    title,
    text,
    confirmationIsValid = undefined,
    setConfirmationIsValid = undefined,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const theme = useTheme();
    const confirm = t('common.confirm').toLowerCase();
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (setConfirmationIsValid == undefined) return;
        const { value } = event.target;
        const keywordMatches = value.toLowerCase().trim() === confirm;
        setConfirmationIsValid(keywordMatches);
    };

    return (
        <Fragment key="step-confirmation">
            <Typography variant="h4" sx={{ paddingBottom: '1.5em' }}>
                {title}
            </Typography>
            <Typography sx={{ whiteSpace: 'break-spaces' }}>{text}</Typography>
            {confirmationIsValid != undefined &&
                setConfirmationIsValid != undefined && (
                    <>
                        <Typography sx={{ whiteSpace: 'break-spaces' }}>
                            <Trans
                                i18nKey="adminBudgetSpace.confirmationModal.validateConfirm"
                                components={{
                                    bold: (
                                        <strong
                                            style={{
                                                color: theme.palette.primary
                                                    .main,
                                            }}
                                        />
                                    ),
                                }}
                            />
                        </Typography>
                        <TextField
                            placeholder={confirm}
                            onChange={onChange}
                            size="small"
                            error={!confirmationIsValid}
                            sx={{ mt: 2 }}
                        />
                    </>
                )}
        </Fragment>
    );
}
